//include 11
jQuery(function () {
  var kidsSingular = window.ppt.translate("kid.singular","Kind");
  var kidsPlural = window.ppt.translate("kid.plural","Kinder");
  var adultsSingular = window.ppt.translate("adult.singular","Erwachsener");
  var adultsPlural = window.ppt.translate("adult.plural","Erwachsene");
  var guestsSingular = "Gast";
  var guestsPlural = "Gäste";
  var adultsAbbr = window.ppt.translate("search.belegung.adult.short","Erw.");//"Erw.";
  var kidsAbbr = window.ppt.translate("search.belegung.kids.short","Kind.");//"Kind.";
  var privateFunctions = {
    checkAndSetPosition(selector) {
      selector.css({
        top: "",
        left: ""
      });

      var overflows = window.pixelpoint.utilities.getOverflows(selector);

      if (overflows.left > 0) {
        var offset = selector.offset(); //always need to update
        selector.offset({
          top: offset.top,
          left: offset.left + overflows.left
        });
      } else if (overflows.right > 0) {
        var offset = selector.offset();
        selector.offset({
          top: offset.top,
          left: offset.left - overflows.right
        });
      }
      if (overflows.top > 0) {
        var offset = selector.offset();
        selector.offset({
          top: offset.top + overflows.top,
          left: offset.left
        });
      } else if (overflows.bottom > 0) {
        var offset = selector.offset();
        selector.offset({
          top: offset.top - overflows.bottom,
          left: offset.left
        });
      }
    },
    parseInt(number) {
      var result = parseInt(number);
      if (isNaN(result)) return 0;
      return result;
    },
    getSelector(picker, selector) {
      var element = picker.find(selector);
      if (element.length == 0) {
        var pickerId = picker.attr("id");
        if (!!pickerId) {
          element = $(`.visitor-picker-layer#for-${pickerId}`).find(selector);
        }
      }
      return element;
    },
    getAdultsCount(picker) {
      var adultInputName = picker.data("adult-input-name");
      return privateFunctions.parseInt(
        privateFunctions
        .getSelector(picker, `input[name='${adultInputName}']`)
        .val()
      );
    },
    getKidsCount(picker) {
      var kidsInputName = picker.data("children-input-name");
      return privateFunctions.parseInt(
        privateFunctions
        .getSelector(picker, `input[name='${kidsInputName}']`)
        .val()
      );
    },
    getMaxKidsCount(picker) {
      return privateFunctions.parseInt(picker.data("max-children-count"));
    },
    get(picker) {
      var adults = privateFunctions.getAdultsCount(picker);
      var kids = privateFunctions.getKidsCount(picker);
      var ages = privateFunctions.getKidsAges(picker);
      return {
        kids: kids,
        adults: adults,
        ages: ages
      };
    },
    setAdultsCount(picker, val) {
      if (val < 0) {
        val = 0;
      }
      if (val > 10) {
        val = 10;
      }
      var adultInputName = picker.data("adult-input-name");
      privateFunctions
        .getSelector(picker, `input[name='${adultInputName}']`)
        .val(val);
    },
    setKidsAgesDisplay(picker, val) {
      val = val || 0;
      privateFunctions
        .getSelector(picker, ".kidsAge .input")
        .removeClass("hide");
      if (val < 4) {
        privateFunctions
          .getSelector(picker, ".kidsAge .input.kid4")
          .addClass("hide");
        privateFunctions
          .getSelector(picker, ".kidsAge .input.kid4 input")
          .val("");
      }
      if (val < 3) {
        privateFunctions
          .getSelector(picker, ".kidsAge .input.kid3")
          .addClass("hide");
        privateFunctions
          .getSelector(picker, ".kidsAge .input.kid3 input")
          .val("");
      }
      if (val < 2) {
        privateFunctions
          .getSelector(picker, ".kidsAge .input.kid2")
          .addClass("hide");
        privateFunctions
          .getSelector(picker, ".kidsAge .input.kid2 input")
          .val("");
      }
      if (val < 1) {
        privateFunctions
          .getSelector(picker, ".kidsAge .input.kid1")
          .addClass("hide");
        privateFunctions
          .getSelector(picker, ".kidsAge .input.kid1 input")
          .val("");
      }
    },
    setKidsCount(picker, val) {
      var kidsInputName = picker.data("children-input-name");
      privateFunctions
        .getSelector(picker, `input[name='${kidsInputName}']`)
        .val(val);
      privateFunctions.setKidsAgesDisplay(picker, val);
    },
    setKidsAges(picker, val) {
      var kidsCount = 0;
      if (!!val.kid1 || val.kid1 === 0) {
        privateFunctions
          .getSelector(picker, ".kidsAge .input.kid1 input")
          .val(val.kid1);
        kidsCount++;
      }
      if (!!val.kid2 || val.kid2 === 0) {
        privateFunctions
          .getSelector(picker, ".kidsAge .input.kid2 input")
          .val(val.kid2);
        kidsCount++;
      }
      if (!!val.kid3 || val.kid3 === 0) {
        privateFunctions
          .getSelector(picker, ".kidsAge .input.kid3 input")
          .val(val.kid3);
        kidsCount++;
      }
      if (!!val.kid4 || val.kid4 === 0) {
        privateFunctions
          .getSelector(picker, ".kidsAge .input.kid4 input")
          .val(val.kid4);
        kidsCount++;
      }
      var setKidsCount = privateFunctions.getKidsCount(picker);
      if (setKidsCount > kidsCount) {
        privateFunctions.setKidsCount(picker, kidsCount);
      }
    },
    getKidsAges(picker, val) {
      var ages = {};
      ages.kid1 = privateFunctions
        .getSelector(picker, ".kidsAge .input.kid1 input")
        .val();
      ages.kid2 = privateFunctions
        .getSelector(picker, ".kidsAge .input.kid2 input")
        .val();
      ages.kid3 = privateFunctions
        .getSelector(picker, ".kidsAge .input.kid3 input")
        .val();
      ages.kid4 = privateFunctions
        .getSelector(picker, ".kidsAge .input.kid4 input")
        .val();
      return ages;
    },
    isCleared(picker) {
      var adultInputName = picker.data("adult-input-name");
      var kidsInputName = picker.data("children-input-name");
      var adults = privateFunctions
        .getSelector(picker, `input[name='${adultInputName}']`)
        .val();
      var kids = privateFunctions
        .getSelector(picker, `input[name='${kidsInputName}']`)
        .val();
      if (adults === "" && kids !== "") {
        privateFunctions
          .getSelector(picker, `input[name='${adultInputName}']`)
          .val(0);
      } else if (adults !== "" && kids === "") {
        privateFunctions
          .getSelector(picker, `input[name='${kidsInputName}']`)
          .val(0);
      }
      adults = privateFunctions
        .getSelector(picker, `input[name='${adultInputName}']`)
        .val();
      kids = privateFunctions
        .getSelector(picker, `input[name='${kidsInputName}']`)
        .val();
      return adults === "" || kids === "";
    },
    update(picker, supressEvent) {
      supressEvent = supressEvent || false;

      if (privateFunctions.isCleared(picker)) {
        var placeholder = picker.data("placeholder") || "Anzahl";
        privateFunctions.getSelector(picker, ">span").html(placeholder);
        privateFunctions.getSelector(picker, ">span").removeClass("filled");
        privateFunctions.getSelector(picker, ".clear").hide();

        var kidsCount = privateFunctions.getKidsCount(picker);
        var adultsCount = privateFunctions.getAdultsCount(picker);
        var guestsCount = kidsCount + adultsCount;
        var kidsAppend = kidsCount == 1 ? kidsSingular : kidsPlural;
        var kidsAbbrevOrFull = kidsCount == 1 ? kidsSingular : kidsAbbr;
        var adultsAppend = adultsCount == 1 ? adultsSingular : adultsPlural;
        var guestsAppend = guestsCount == 1 ? guestsSingular : guestsPlural;
        privateFunctions
          .getSelector(picker, ".selector .adults span")
          .text(`${adultsCount} ${adultsAppend}`);
        privateFunctions
          .getSelector(picker, ".selector .children span")
          .text(`${kidsCount} ${kidsAppend}`);
        privateFunctions.setKidsAgesDisplay(picker, 0);
      } else {
        var kidsCount = privateFunctions.getKidsCount(picker);
        var adultsCount = privateFunctions.getAdultsCount(picker);
        var guestsCount = kidsCount + adultsCount;
        var kidsAppend = kidsCount == 1 ? kidsSingular : kidsPlural;
        var kidsAbbrevOrFull = kidsCount == 1 ? kidsSingular : kidsAbbr;
        var adultsAppend = adultsCount == 1 ? adultsSingular : adultsPlural;
        var guestsAppend = guestsCount == 1 ? guestsSingular : guestsPlural;
        //picker.find(">span").text(`${guestsCount} ${guestsAppend}`);
        privateFunctions
          .getSelector(picker, ">span")
          .html(
            `<span class="adultsDisplay">${adultsCount} ${adultsAbbr}</span><span class="kidsDisplay">${kidsCount} ${kidsAbbrevOrFull}</span>`
          );
        privateFunctions.getSelector(picker, ">span").addClass("filled");
        privateFunctions
          .getSelector(picker, ".selector .adults span")
          .text(`${adultsCount} ${adultsAppend}`);
        privateFunctions
          .getSelector(picker, ".selector .children span")
          .text(`${kidsCount} ${kidsAppend}`);
        privateFunctions.getSelector(picker, ".clear").show();
      }

      if (!supressEvent) {
        var eventsPostfix = picker.data("events-postfix") || null;
        if (!!eventsPostfix) {
          var visitors = privateFunctions.get(picker);
          window.pixelpoint.pubSub.publish(
            `${window.pixelpoint.pubSub.events
              .belegungChange}:inverse:${eventsPostfix}`, [visitors]
          );
        }
      }
    },
    toggleDisable(disableOrEnable, picker) {
      if (!!disableOrEnable) {
        privateFunctions.getSelector(picker, "input").prop("disabled", true);
        picker.data("is-disabled", true);
        picker.removeClass("active");
      } else {
        privateFunctions.getSelector(picker, "input").prop("disabled", false);
        picker.data("is-disabled", false);
      }
    },
    validate(picker, showErrors, forceOpen) {
      var valid = true;
      if (picker.data("is-disabled") == true) {
        return valid;
      }
      picker.removeClass("invalid");
      $(`.visitor-picker-layer`).removeClass("invalid");

      showErrors = showErrors || false;
      forceOpen = forceOpen || false;
      var kids = privateFunctions.getKidsCount(picker);
      var ages = privateFunctions.getKidsAges(picker);
      var numberOfKidsSet = 0;
      if (ages.kid1 !== undefined && !isNaN(parseInt(ages.kid1))) {
        numberOfKidsSet++;
      }
      if (ages.kid2 !== undefined && !isNaN(parseInt(ages.kid2))) {
        numberOfKidsSet++;
      }
      if (ages.kid3 !== undefined && !isNaN(parseInt(ages.kid3))) {
        numberOfKidsSet++;
      }
      if (ages.kid4 !== undefined && !isNaN(parseInt(ages.kid4))) {
        numberOfKidsSet++;
      }
      if (numberOfKidsSet < kids) {
        valid = false;
        if (showErrors) {
          picker.addClass("invalid");
          if (forceOpen) picker.addClass("active");

          if ($(`.visitor-picker-layer`).length > 0) {
            var pickerId = picker.attr("id");
            if (!!pickerId) {
              $(`.visitor-picker-layer#for-${pickerId}`).addClass("invalid");
            }
          }
        }
      }
      return valid;
    },
    clear($this) {
      var adultInputName = $this.data("adult-input-name");
      var kidsInputName = $this.data("children-input-name");
      privateFunctions
        .getSelector($this, `input[name='${adultInputName}']`)
        .val("");
      privateFunctions
        .getSelector($this, `input[name='${kidsInputName}']`)
        .val("");
      privateFunctions.update($this);
    },
    init($this) {
      //var $this = $(this);
      var adultInputName = $this.data("adult-input-name") || "numberOfAdults";
      var kidsInputName =
        $this.data("children-input-name") || "numberOfChildren";
      var kid1InputName = $this.data("kid-a-input-name") || "kid1";
      var kid2InputName = $this.data("kid-b-input-name") || "kid2";
      var kid3InputName = $this.data("kid-c-input-name") || "kid3";
      var kid4InputName = $this.data("kid-d-input-name") || "kid4";
      var maxKidsCount = $this.data("max-children-count") || 4;
      var maxAdultsCount = $this.data("max-adults-count") || -1;
      var placeholder = $this.data("placeholder") || "Anzahl";
      var eventsPostfix = $this.data("events-postfix") || null;
      var disabled = $this.is("[data-disabled]");

      var elementId = $this.attr("id");
      if (!elementId) {
        elementId = Math.random()
          .toString(36)
          .substring(5);
        $this.attr("id", elementId);
      }

      var initialChildrenCount = $this.data("num-of-children") || 0;
      var initialAdultCount = $this.data("num-of-adults") || 2;

      if (maxAdultsCount > -1 && initialAdultCount > maxAdultsCount)
        initialAdultCount = maxAdultsCount;

      var initialKid1Age =
        $this.data("kid-a-age") !== undefined ? $this.data("kid-a-age") : "";
      var initialKid2Age =
        $this.data("kid-b-age") !== undefined ? $this.data("kid-b-age") : "";
      var initialKid3Age =
        $this.data("kid-c-age") !== undefined ? $this.data("kid-c-age") : "";
      var initialKid4Age =
        $this.data("kid-d-age") !== undefined ? $this.data("kid-d-age") : "";
      if (initialChildrenCount > maxKidsCount)
        initialChildrenCount = maxKidsCount;

      var hideClear = false;
      if ($this.is("[data-supress-default-values]")) {
        initialChildrenCount = "";
        initialAdultCount = "";
        hideClear = true;
      }

      var removeTitle = $this.data("remove-title");
      var closeTitle = $this.data("close-title");

      var adultTranslation = window.ppt.translate("adult.plural","Erwachsene");
      var kidsTranslation = window.ppt.translate("kid.plural","Kinder");
      var kidsAgeTranslation1 = window.ppt.translate("kids.age","Alter %s. Kind:",[1]);
      var kidsAgeTranslation2 = window.ppt.translate("kids.age","Alter %s. Kind:",[2]);
      var kidsAgeTranslation3 = window.ppt.translate("kids.age","Alter %s. Kind:",[3]);
      var kidsAgeTranslation4 = window.ppt.translate("kids.age","Alter %s. Kind:",[4]);
      var YearShortTranslation = window.ppt.translate("search.belegung.year.long","J.");

      $this.data("adult-input-name", adultInputName);
      $this.data("children-input-name", kidsInputName);
      $this.data("max-children-count", 4);
      $this.html(
        `
        <input type="hidden" name="${adultInputName}" value="${initialAdultCount}" />
        <input type="hidden" name="${kidsInputName}" value="${initialChildrenCount}" />
        <span>${placeholder}</span>
        <div class="selector">
          <div class="selector-part row adults">
              <div class="columns large-6 small-6 no-padding">
                <span>0 ${adultTranslation}</span>
              </div>
              <div class="columns large-6 small-6 no-padding text-right">
                <button class="button decrease">-</button>
                <button class="button increase">+</button>
              </div>
          </div>
          <div class="selector-part row children">
              <div class="columns large-6 small-6 no-padding">
                <span>0 ${kidsTranslation}</span>
              </div>
              <div class="columns large-6 small-6 no-padding text-right">
                <button class="button decrease">-</button>
                <button class="button increase">+</button>
              </div>
        </div>
        <div class="selector-part row child-ages">
              <div class ="columns large-12 small-12 kidsAge">
                <div class ="input hide kid1">
                    <label for="${elementId}-kid-1">${kidsAgeTranslation1} </label>
                    <input id="${elementId}-kid-1" type="number" min="0" max="17" name="${kid1InputName}" value="${initialKid1Age}" /> ${YearShortTranslation}
                </div>
                <div class ="input hide kid2">
                    <label for="${elementId}-kid-2">${kidsAgeTranslation2} </label>
                    <input id="${elementId}-kid-2" type="number" min="0" max="17" name="${kid2InputName}" value="${initialKid2Age}" /> ${YearShortTranslation}
                </div>
                <div class ="input hide kid3">
                    <label for="${elementId}-kid-3">${kidsAgeTranslation3} </label>
                    <input id="${elementId}-kid-3" type="number" min="0" max="17" name="${kid3InputName}" value="${initialKid3Age}" /> ${YearShortTranslation}
                </div>
                <div class ="input hide kid4">
                    <label for="${elementId}-kid-4">${kidsAgeTranslation4} </label>
                    <input id="${elementId}-kid-4" type="number" min="0" max="17" name="${kid4InputName}" value="${initialKid4Age}" /> ${YearShortTranslation}
                </div>
              </div>              
          </div>
          <button class="close-selector"><i class="icon-close" title="` +
        closeTitle +
        `"></i></button>
        </div>
        <button class="clear"><i class="icon-close" title="` + removeTitle + `"></i></button>
      `
      );

      var selector = $this.find(".selector");

      if (
        $("body").find(`.visitor-picker-layer#for-${elementId}`).length == 0
      ) {
        $("body").append(
          `<div id="for-${elementId}" class="visitor-picker-layer hide"></div>`
        );
        $("body .visitor-picker-layer").click(function (e) {
          e.preventDefault();
          e.stopPropagation();
        });
      }
      var selectorIsGlobal = false;
      if (window.pixelpoint.isMobile.isMobileWidth()) {
        $(`body .visitor-picker-layer#for-${elementId}`).append(selector);
        var saveTranslation = window.ppt.translate('action.save','Speichern');
        selector.append(`<a class="brandenbutton save-values">${saveTranslation}</a>`);
        selector.on("click touchstart", ".save-values", function (e) {
          e.preventDefault();
          e.stopPropagation();
          if (privateFunctions.validate($this, true)) {
            $(`.visitor-picker-layer#for-${elementId}`).addClass("hide");
          }
        });
        selectorIsGlobal = true;
      }

      if (!!hideClear) {
        privateFunctions.getSelector($this, ".clear").hide();
      }

      $this.addClass("initialized");
      
      var activatePicker = function(e) {
        e.preventDefault();
        if ($this.data("is-disabled") == true) {
          return;
        }
        $this.addClass("active");

        if (selectorIsGlobal) {
          $(`.visitor-picker-layer#for-${elementId}`).removeClass("hide");
        } else {
          privateFunctions.checkAndSetPosition($this.find(".selector"));
        }
      };
      $this.on("click", activatePicker); 
      $this.on("keydown", function (e) {
        if (e.key === "Enter" || e.keyCode === 13) {
          activatePicker(e);
        }
      });

      var increaseAdults = function(e) {
        e.preventDefault();
        var adults = privateFunctions.getAdultsCount($this);
        adults++;
        if (maxAdultsCount > -1 && adults > maxAdultsCount)
          adults = maxAdultsCount;
        privateFunctions.setAdultsCount($this, adults);
        privateFunctions.update($this);
      };

      var decreaseAdults = function(e) {
        e.preventDefault();
        var adults = privateFunctions.getAdultsCount($this);
        adults--;
        if (adults < 0) adults = 0;
        privateFunctions.setAdultsCount($this, adults);
        privateFunctions.update($this);
      };

      var increaseChildren = function(e) {
        e.preventDefault();
        var kids = privateFunctions.getKidsCount($this);
        kids++;
        if (kids > privateFunctions.getMaxKidsCount($this)) kids = 4;
        privateFunctions.setKidsCount($this, kids);
        privateFunctions.update($this);
      };

      var decreaseChildren = function(e) {
        e.preventDefault();
        var kids = privateFunctions.getKidsCount($this);
        kids--;
        if (kids < 0) kids = 0;
        privateFunctions.setKidsCount($this, kids);
        privateFunctions.update($this);
      };

      selector.on("click", ".adults .increase", increaseAdults);
      selector.on("keydown", ".adults .increase", function (e) {
        if (e.key === "Enter" || e.keyCode === 13) {
          increaseAdults(e);
        }
      });

      selector.on("click", ".adults .decrease", decreaseAdults);
      selector.on("keydown", ".adults .decrease", function (e) {
        if (e.key === "Enter" || e.keyCode === 13) {
          decreaseAdults(e);
        }
      });

      selector.on("click", ".children .increase", increaseChildren);
      selector.on("keydown", ".children .increase", function (e) {
        if (e.key === "Enter" || e.keyCode === 13) {
          increaseChildren(e);
        }
      });

      selector.on("click", ".children .decrease", decreaseChildren);
      selector.on("keydown", ".children .decrease", function (e) {
        if (e.key === "Enter" || e.keyCode === 13) {
          decreaseChildren(e);
        }
      });

      var clearPicker = function(e) {
        e.preventDefault();
        privateFunctions.clear($this);
      };

      $this.on("click", ".clear", clearPicker);
      $this.on("keydown", ".clear", function (e) {
        if (e.key === "Enter" || e.keyCode === 13) {
          clearPicker(e);
        }
      });
      var closeSelector = selector.find(".close-selector");
      $(document).on("mouseup touchend", function (e) {
        if (!selector.is(e.target) && !$.contains(selector[0], e.target)) {
          if (privateFunctions.validate($this, true)) {
            $this.removeClass("active");
            if (selectorIsGlobal) {
              $(`.visitor-picker-layer#for-${elementId}`).addClass("hide");
            }
          }
        }
      });

      var closePicker = function(e) {
        e.preventDefault();
        e.stopPropagation();
        $this.removeClass("active");
        if (selectorIsGlobal) {
          $(`.visitor-picker-layer#for-${elementId}`).addClass("hide");
        }
      };
      
      selector.find(".close-selector").on("click", closePicker);
      selector.find(".close-selector").on("keydown", function (e) {
        if (e.key === "Enter" || e.keyCode === 13) {
          closePicker(e);
        }
      });
      // Add ESC key listener specifically for this picker's selector
      selector.on("keydown", function (e) {
        if (e.key === "Escape" || e.keyCode === 27) {
          closePicker(e);
        }
      });

      var exposedFunctions = {
        set(data, supressEvent) {
          privateFunctions.setKidsCount($this, data.kids);
          privateFunctions.setAdultsCount($this, data.adults);
          privateFunctions.setKidsAges($this, data.ages);
          privateFunctions.update($this, supressEvent);
        },
        get() {
          return privateFunctions.get($this);
        },
        disable() {
          privateFunctions.toggleDisable(true, $this);
        },
        enable() {
          privateFunctions.toggleDisable(false, $this);
        },
        valid(forceOpen) {
          return privateFunctions.validate($this, true, forceOpen);
        },
        reset() {
          privateFunctions.clear($this);
        }
      };
      $this
        .data("form-element-functions", exposedFunctions)
        .attr("data-form-element-functions-added", true);

      if (initialAdultCount > 0 || initialChildrenCount > 0) {
        privateFunctions.setKidsCount($this, initialChildrenCount);
        privateFunctions.setAdultsCount($this, initialAdultCount);
        privateFunctions.update($this);
      }

      if (!!eventsPostfix) {
        window.pixelpoint.pubSub.subscribe(
          `${window.pixelpoint.pubSub.events.belegungChange}:${eventsPostfix}`,
          function (e, visitors) {
            exposedFunctions.set(visitors, true);
          }
        );
        $this.find(".kidsAge input").on("change", function () {
          var visitors = privateFunctions.get($this);
          window.pixelpoint.pubSub.publish(
            `${window.pixelpoint.pubSub.events
              .belegungChange}:inverse:${eventsPostfix}`, [visitors]
          );
        });
      }

      if (!!disabled) {
        privateFunctions.toggleDisable(true, $this);
        $this.closest(".control").addClass("disabled");
      }
    }
  };

  window.pixelpoint.ppComponents.visitorPicker = function ($this) {
    privateFunctions.init($this);
  };

  $(".visitor-picker").each(function () {
    window.pixelpoint.ppComponents.visitorPicker($(this));
  });
});